import { AxiosInstance } from 'axios'

export type LoginChoices = {
  pharmaceuticals: {
    id: number
    name: string
    person: boolean
    clinic: boolean
  }[]
  admin: boolean
}

export function authEndpoints(apiClient: AxiosInstance) {
  return {
    login({
      login,
      password,
      codeToLogin,
      pharmaceuticalId,
      chosenUser,
      checkPasswordExpiration = true,
    }: {
      login: string
      password?: string
      codeToLogin?: string
      pharmaceuticalId?: number
      chosenUser?: string
      checkPasswordExpiration?: boolean
    }): Promise<{
      token: string
      refreshToken: string
      expiringAction: string | null
    }> {
      return apiClient.post(
        `auth`,
        { login, password, codeToLogin, pharmaceuticalId, chosenUser, checkPasswordExpiration },
        { withCredentials: true },
      )
    },
    loginChoices(data: { login: string; password: string }): Promise<LoginChoices> {
      return apiClient.post('get-login-choices', data)
    },
    logout({ clearActiveSession, sessionId }: { sessionId?: string; clearActiveSession?: boolean } = {}) {
      /*
      return apiClient.patch(
        sessionId ? `logout/${sessionId}` : 'logout',
        {},
        { withCredentials: true, params: { clearActiveSession } },
      )
        */
    },
    forgotPassword(login: string): Promise<void> {
      return apiClient.post(`user/forgot-password`, { login })
    },
    generateResetPasswordCode(): Promise<{ resetPasswordCode: string }> {
      return apiClient.patch('generate-reset-password-code')
    },
  }
}
